import Livia71 from './Livia 7 (1).webp'
import Livia72 from './Livia 7 (2).webp'
import Livia73 from './Livia 7 (3).webp'
import Livia74 from './Livia 7 (4).webp'
import Livia75 from './Livia 7 (5).webp'
import Livia76 from './Livia 7 (6).webp'
import Livia77 from './Livia 7 (7).webp'


const Livia7images =[
   Livia71,Livia72,Livia73,Livia74,Livia75,Livia76,Livia77
]

export default Livia7images;